import { getRequest } from '@tencent/web-base';
import { isMobileBrowser } from '@utils/browser';
import { Navigate } from 'react-router-dom';

const AccessCheck: React.FunctionComponent = ({ children }) => {
  const ableH5 = getRequest('h5', window.location.href) === '1';
  // 放开测试一下
  if (isMobileBrowser() && !ableH5) {
    console.log('去提示页');
    return <Navigate to="/suspence" />;
  }
  return <>{children}</>;
};

export default AccessCheck;
